import React from "react";
import { Badge } from "../../../stores/BadgeStore/Types";

interface Props {
  badge: Badge;
  onOpen: (badge: Badge) => void;
}

const BadgeCard: React.FC<Props> = ({ badge, onOpen }) => {
  const earned = badge.persisted;
  const label = earned ? badge.badge_name : "Locked";
  const ariaLabel = `${badge.badge_name} badge, ${
    earned ? "earned" : "locked"
  }. Activate to ${earned ? "view" : "see how to earn it"}.`;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault();
      onOpen(badge);
    }
  };

  return (
    <div
      className={`bd-card ${earned ? "earned" : "locked"}`}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={() => onOpen(badge)}
      onKeyDown={handleKeyDown}
    >
      <div className={`bd-disc ${earned ? "is-earned" : "is-locked"}`}>
        {earned ? (
          <span className="bd-art">
            <img src={badge.badge_url} alt="" loading="lazy" />
          </span>
        ) : (
          <span className="ph-mark">Locked</span>
        )}
      </div>
      <div className="bd-name">{label}</div>
    </div>
  );
};

export default BadgeCard;
